import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { ViewFrame } from '../../components';
import ProfileTab from './tab-profile/ProfileTab';
import { selectCurrentUser } from '../../store/modules/users/selectors';
import BillingTab from './tab-billing/BillingTab';
import TabRedirect from '../../components/tab-redirect/TabRedirect';
import SideTabs from '../../components/side-tabs/SideTabs';
import AdjustmentsButtonGroup from '../users/AdjustmentsButtonGroup/AdjustmentsButtonGroup';
import { useGuard } from '../../hooks';
import { is, roles } from '../../utility/guard';
import InvoiceCreate from '../billing/Invoices/InvoiceCreate';

const Profile = () => {
  const user = useSelector(selectCurrentUser);
  const { path } = useRouteMatch();
  const isSuperAdmin = useGuard(is(roles.superAdmin));
  const showAdjustmentCreditsPanel = isSuperAdmin && path.search('billing/credit-history') !== -1;
  const showInvoicePanel = isSuperAdmin && path.search('billing/invoices') !== -1;

  return (
    <ViewFrame
      title={`${user.data?.first_name} ${user.data?.last_name}`}
      actionPanel={(
        <>
          {user.data && showAdjustmentCreditsPanel && (<AdjustmentsButtonGroup user={user.data!} />)}
          {user.data && showInvoicePanel && (<InvoiceCreate userId={user.data!.id} />)}
        </>
      )}
    >
      <TabRedirect />
      <Grid container spacing={1}>
        <Grid item lg={2} xs={12}>
          {!user.loading && (<SideTabs variant="profile" />)}
        </Grid>
        <Grid item xs={12} lg={10}>
          <Switch>
            <Route>
              <ProfileTab />
              <BillingTab />
            </Route>
          </Switch>
        </Grid>
      </Grid>
    </ViewFrame>
  );
};

export default Profile;
